module.exports = __webpack_public_path__ + "images/onboarding-experiment/inline-inspirations-picker.f545f2bf71c411147b63.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/onboarding-experiment/inline-inspirations-picker.png
// module id = hbDt
// module chunks = 12